import { InputLabelProps } from "@mui/material";

export const extendedMUIInputLabelProps = <T extends { "data-testid"?: string }>(
  props: Partial<InputLabelProps> & T
) => props as Partial<InputLabelProps>;
